import React from "react";
import { SpendablesForModules } from "../interfaces/SpendablesForModules";

interface ISpendablesContext {
  moduleSpendables: SpendablesForModules;
}

export const SpendablesContext = React.createContext<ISpendablesContext>({
  moduleSpendables: {},
});
